export default {"src":"/_next/static/media/modern-room-names.838bfc73.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};